import { SonarText } from './text';
import { SonarUser } from './SonarUser';
import { SonarUserTooltip } from './SonarUserTooltip';
import { Space } from 'antd';
import { StakeholderAvatar } from './avatar';
import { useStakeholderReference } from '@hooks';

import React, { ReactNode } from 'react';

export interface SonarStakeholderProps {
	avatar?: boolean;
	className?: string;
	large?: boolean;
	placeholder?: ReactNode;
	showTooltip?: boolean;
	stakeholderId: number;
	withFullName?: boolean;
}

export const SonarStakeholder: React.FC<SonarStakeholderProps> = ({
	avatar = true,
	className,
	large,
	placeholder,
	showTooltip,
	stakeholderId,
	withFullName = true
}) => {
	const { name, email, userId } = useStakeholderReference(stakeholderId);

	if (userId) {
		return <SonarUser
			showTooltip={ showTooltip }
			userId={ userId } />;
	}

	let avatarElement;
	let labelElement;

	if (avatar) {
		avatarElement = <StakeholderAvatar
			className={ className }
			large={ large }
			stakeholderId={ stakeholderId } />;
	}

	if (withFullName || placeholder) {
		labelElement = <SonarText className='stakeholder-label'>{ name || placeholder }</SonarText>;
	}

	const stakeholderBase =
		<Space
			className='sonar-stakeholder'
			key={ stakeholderId }
			size={ 8 }>
			{ avatarElement }
			{ labelElement }
		</Space>;
	if (showTooltip) {
		return (
			<SonarUserTooltip
				avatar={ avatarElement }
				email={ email }
				name={ name }>
				{ stakeholderBase }
			</SonarUserTooltip>
		);
	}

	return stakeholderBase;
};
